// Add products to cart
window.addEventListener('load', function(event) {
    let buttons = document.querySelectorAll('.cta-qa__option'),
        submitBtn = document.querySelector('.cta-qa__submit'),
        submitText = submitBtn.querySelector('.js-cta-qa-price'),
        instance = document.querySelector("cart-drawer"),
        variantID = document.querySelector('.PdpHero-variant.activeVar') ? document.querySelector('.PdpHero-variant.activeVar').dataset.id : submitBtn.dataset.id,
        price,
        data,
        config;

        data = new FormData();
        data.append("id", variantID);
        data.append("quantity", 1);
        data.append(
            'sections',
            instance.getSectionsToRender().map((section) => section.id)
        );
        data.append('sections_url', window.location.pathname);
        config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = data;

    if (buttons.length) {
        buttons.forEach(button => {
            button.addEventListener('click', function(){
                variantID = this.dataset.id;
                price = this.dataset.price;

                submitText.textContent = price;
                document.querySelector('.cta-qa__option--selected').classList.remove('cta-qa__option--selected');
                this.classList.add('cta-qa__option--selected');

                data = new FormData();
                data.append("id", variantID);
                data.append("quantity", 1);
                data.append(
                    'sections',
                    instance.getSectionsToRender().map((section) => section.id)
                );
                data.append('sections_url', window.location.pathname);
                config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                config.body = data;
            });
        });

        let variantTitle = document.querySelector('.cta-qa__option').dataset.title;
        document.querySelector('.cta-qa__option').closest('.cta-qa__list').querySelector('.js-cta-qa-option').textContent = variantTitle;
    } else {
        data = new FormData();
        data.append("id", variantID);
        data.append("quantity", 1);
        data.append(
            'sections',
            instance.getSectionsToRender().map((section) => section.id)
        );
        data.append('sections_url', window.location.pathname);
        config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = data;
    }

    submitBtn.addEventListener('click', function(){
		fetch('/cart/add.js', config)
			.then(response => response.json())
				.then(cart_item => {
					// Handle the response after adding the item to the cart
					instance.renderContents(cart_item);
					document.querySelector(".cart-drawer__form").style.display = "flex";
				}).catch(error => {
					// Handle any errors that occur during the request
					console.error('Error adding item to cart:', error);
				});
    })
}, false);